import './consumerCategoriesPicker.scss';

import { FormattedMessage } from 'react-intl';
import { Chip, ChipGroup } from '@eliberty/design-system-react';

import { ConsumerCategory } from '~types/appsync.types';

type ConsumerCategoriesPickerProps = {
  categories: ReadonlyArray<ConsumerCategory>;
  value: string | null;
  onChange: (value: string | null) => void;
  classNamePrefix?: string;
  testIdPrefix?: string;
};

const ConsumerCategoriesPicker = ({
  categories,
  value,
  onChange,
  classNamePrefix = 'ConsumerCategoriesPicker',
  testIdPrefix,
}: ConsumerCategoriesPickerProps) => {
  if (categories.length === 0) return null;

  const prefix = classNamePrefix;
  const testPrefix = testIdPrefix ?? classNamePrefix;

  return (
    <div className={`${prefix}_priceForConsumerCategory`}>
      <div className={`${prefix}_consumerCategoriesTitle`}>
        <FormattedMessage id='showPricesFor' defaultMessage='Show prices for :' />
      </div>
      <div className={`${prefix}_consumerCategories`}>
        <ChipGroup onChange={onChange} value={value}>
          {categories.map((cat) => (
            <Chip
              data-testid={`${testPrefix}_consumerCategory`}
              key={cat.shortname}
              label={cat.name}
              value={cat.shortname}
            />
          ))}
        </ChipGroup>
      </div>
    </div>
  );
};

export default ConsumerCategoriesPicker;
